export default {
      id: "bar_chart_active-usage",
      viewBox: "0 0 40 37",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#bar_chart_active",
      toString: function () {
        return this.url;
      }
    }